import { useContext, useState } from 'react';
import { UserContext } from '../../App';
import useErrorHandler from '../../hooks/useErrorHandler';
import { sendMessage } from '../../requests/requests';
import { ButtonType } from '../../types/enums';
import Button from '../Button/Button';
import Textarea from '../Input/Textarea';

import styles from './Contact.module.scss';

const Contact = () => {
  const { user } = useContext(UserContext);
  const errorHandler = useErrorHandler();
  const [message, setMessage] = useState('');
  const [isSent, setIsSent] = useState(false);

  const onSubmit = () => {
    if (!message) return;

    sendMessage(message, user!.email, user!.name)
      .then(() => {
        setIsSent(true);
      })
      .catch(errorHandler);
  };

  if (isSent) {
    return (
      <div className={styles.successContainer}>
        <h1>Thank you for contacting us!</h1>
        <p>We will get back to you within a business day.</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1>Contact us</h1>
      <Textarea
        value={message}
        setValue={setMessage}
        label="What can we help you with?"
        placeholder="Type your message here"
        id="message"
      />
      <Button type={ButtonType.PRIMARY} action={onSubmit}>
        Send message
      </Button>
      <p>You can expect a meaningful reply within a business day.</p>
    </div>
  );
};

export default Contact;
